<template>
  <div class="main" id="sched">
    <!--  -->
    <div class="row">
      <div class="banner_schedule pc">
        <span>会议日程</span>
        <h1 class="sch_h1"></h1>
        <p class="sch_p1"></p>
        <p class="sch_p"></p>
      </div>
      <div class="wap_banner_schedule mob">
        <h1 class="sch_h1 sch_wap_h1"></h1>
        <p class="sch_p1"></p>
        <p class="sch_p"></p>
      </div>
    </div>
    <div class="richengall pc">
      <div class="richeng row ">
        <ul class="content content_pc row"></ul>
      </div>
    </div>
    <div class="mob row wap_richeng">
      <ul class="wap_daohang row"></ul>
      <ul class="wap_content row"></ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable curly */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable no-redeclare */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import $ from 'jquery'

export default {
  name: 'Schedule',
  data () {
    return {}
  },
  created () {
    this.getSchedule()
  },
  methods: {
    getQueryString: function (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return (r[2])
      return null
    },
    getSchedule: function () {
      $('.daohang>li>a').click(function () {
        $(this)
          .parents('li')
          .addClass('active')
        $(this)
          .parents('li')
          .siblings()
          .removeClass('active')
      })
      $('#wap_richeng>a').click(function () {
        $(this).addClass('active_ri')
        $(this)
          .siblings()
          .removeClass('active_ri')
      })

      // let gqs = _this.getQueryString("project");
      // console.log('gqs ',gqs);
      // if (_this.getQueryString("project") != null) {
      //   var newId = _this.getQueryString("project");
      // }

      // 获取全部会议信息
      var area_id = this.global.area_id
      if (this.$route.query.sid) {
        area_id = this.$route.query.sid
      }
      area_id = area_id.toString()
      var url_schedule = this.global.url.schedule + area_id
      var _this = this

      if (!this.global.config[area_id]) {
        console.log('不存在')
      }

      if (area_id === '2691' || area_id === '2690' || area_id === '2721' || area_id === '2762') {
        // 2021上海||天津||北京||大连mpd，天津|北京过滤第二日下午的数据
        $.ajax({
          type: 'get',
          url: url_schedule,
          dataType: 'jsonp',
          success: function (obj) {
            // console.log("2021mpd schedule  ",obj);
            if (obj.errno && obj.errno.toString() === '0') {
              // console.log(" this.global.config ",_this.global.config);
              $('.sch_h1').text(_this.global.config[area_id].title)
              $('.sch_p1').text(_this.global.config[area_id].trueplace)
              // $(".sch_h1").text(config[area_id].title+'-'+config[area_id].trueplace);
              $('.sch_wap_h1').text(
                _this.global.config[area_id].year + _this.global.config[area_id].title + '站MPD日程'
              )
              // 判断是否为pc
              if (IsPC()) {
                /// /////////////////////////////////////////////
                // 根据obj.data.finishing的元素个数算出天数
                var days_key = Object.keys(obj.data.finishing)
                // console.log(days_key);return false;
                // console.log(days_key.length);
                // 最外层按照日程 第一层循环 ---开始

                // let courseClassNum = 0;
                let courseClass = ''
                let courseList = []
                for (var i = 0; i < days_key.length; i++) {
                  // 处理天的操作**********写日期大标题
                  // console.log(days_key[1]);
                  // var li_pre ='<li class="show"><table class="title" id="'+days_key[i]+'">';****
                  $('.sch_p').text(
                    _this.global.formatTime(days_key[0], 'Y.M.D') +
                      '~' +
                      _this.global.formatTime(days_key[1], 'D')
                  )
                  var li_pre =
                    '<h1>' +
                    _this.global.formatTime(days_key[i], 'Y年M月D日') +
                    '</h1>' +
                    '<li class="show" id="' +
                    days_key[i] +
                    '">'
                  $('.content').append(li_pre)

                  // 计算每一天内上下午总个数
                  var apms_key = Object.keys(obj.data.finishing[days_key[i]])
                  var apms_nums = apms_key.length
                  // var apms_nums = [0,0];
                  // console.log(apms_nums);

                  // 判断上下午
                  var has_am = false
                  var has_pm = false
                  var apms_str = JSON.stringify(apms_key)
                  // console.log(apms_key);
                  // console.log("apms_",apms_str);
                  // var apms_arr = apms_str.split('["')[1].split('"]')[0].split('","');
                  // apms_arr.forEach(function(x,i,a){
                  //   // console.log(x,i,a);
                  //   if(x.indexOf("am")!=-1) apms_nums[0]++;
                  //   if(x.indexOf("pm")!=-1) apms_nums[1]++;
                  // });
                  // console.log("_______________________");

                  // 判断是否有上午
                  if (apms_str.indexOf('am') !== -1) {
                    has_am = true
                  }
                  // 判断是否有下午
                  if (apms_str.indexOf('pm') !== -1) {
                    has_pm = true
                  }
                  // 根绝上下午判断循环次数
                  if (has_am && has_pm) {
                    apms_nums = apms_nums / 2
                  }

                  // 如果有上午  则开始上午处理
                  if (has_am) {
                    // 追加上午的div start************
                    $('#' + days_key[i]).append(
                      '<div class="shangwu"> <table class="title" id="sw_' +
                        days_key[i] +
                        '" >'
                    )
                    // console.log(obj.data.finishing[days_key[i]][j+'am'])
                    // 第二层循环A上午 填充标题操作 --开始
                    var tr_str =
                      '<tr class="top"><td><img src="../../static/images/sch_time.png"/></td>'
                    for (var j = 1; j <= apms_nums; j++) {
                      var fpstr = obj.data.finishing[days_key[i]][j + 'am'].producers
                      var pstr = (fpstr && fpstr !== '' && fpstr != null) ? fpstr : ''
                      tr_str +=
                        '<td><img src="../../static/images/richeng/rc_0' +
                        j +
                        '.png" class="rc_img" /><h2>' +
                        obj.data.finishing[days_key[i]][j + 'am'].name +
                        '<br>' + pstr +
                        '</h2></td>'
                      // 上午标题操作****头像也在此处理************
                      // $(".content .title .shangwu .top").append('<td><img src="images/richeng/rc_01.png" class="rc_img" /></td>');
                      // console.log(obj.data.finishing[days_key[i]][j+'am'].name);
                      // console.log(obj.data.finishing[days_key[i]][j+'am'].producers);
                    }
                    // 第二层循环A上午 填充标题操作 --结束
                    tr_str += '</tr>'
                    $('.shangwu #sw_' + days_key[i]).append(tr_str)

                    // 计算上午的时间点个数
                    var nodes_key = Object.keys(obj.data.datas[days_key[i]]['am'])
                    var nodes_nums = nodes_key.length
                    // console.log(nodes_nums);
                    // 第二层循环B上午 时间点循环 --开始
                    // console.log(obj.data.datas[days_key[i]]['am']);

                    for (var m = 0; m < nodes_nums; m++) {
                      var tr_str_kc =
                        '<tr class="kecheng">' +
                        '<td><b>' +
                        _this.global.formatTime(days_key[i], 'Y/M/D') +
                        getWeek(new Date(_this.global.formatTime(days_key[i], 'Y/M/D'))) +
                        '</b><br><br>' +
                        obj.data.datas[days_key[i]]['am'][nodes_key[m]]['time'][0] +
                        '<br>-<br>' +
                        obj.data.datas[days_key[i]]['am'][nodes_key[m]]['time'][1] +
                        '</td>'

                      // 当前时间点的操作****************
                      // console.log(nodes_key[m]);
                      // 第三层循环 时间点内容填充 --开始
                      // console.log(obj.data.datas[days_key[i]]['am'][nodes_key[m]]);
                      for (var n = 1; n <= apms_nums; n++) {
                        //* *************
                        tr_str_kc += '<td valign="top">'
                        if (typeof obj.data.datas[days_key[i]]['am'][nodes_key[m]][n] === 'undefined') {
                          // console.log('敬请期待');
                          // courseClassNum ++;
                          courseList.push({})
                          // console.log(courseClassNum,courseList);
                          tr_str_kc +=
                            '<div style="line-height: 180px;text-align: center;">敬请期待</div>'
                        } else {
                          // console.log(obj.data.datas[days_key[i]]['am'][nodes_key[m]]);
                          // courseTitle
                          courseClass = 'course' + area_id + obj.data.datas[days_key[i]]['am'][nodes_key[m]][n].courseId
                          // courseClassNum ++;
                          courseList.push({class: courseClass, aid: area_id, id: obj.data.datas[days_key[i]]['am'][nodes_key[m]][n].courseId})
                          // console.log(courseClass,courseClassNum,courseList);
                          tr_str_kc +=
                            '<a class="' + courseClass + '"' +
                            // ' href="/course?id=' +
                            // obj.data.datas[days_key[i]]["am"][nodes_key[m]][n].courseId +
                            // "&sid=" + area_id + '"' +
                            '>' +
                            '<div class="biaoti">' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .courseTitle +
                            '</div>' +
                            '<!-- <div class="img">' +
                            '<img src="../../static/images/anli_logo.png"/>' +
                            '</div> -->'

                          var lecturers_key = Object.keys(
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers
                          )

                          var lecturers_nums =
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers.length

                          // 上午展示一堂课的讲师第一个人
                          tr_str_kc +=
                            '<div class="ren">' +
                            '<h2>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0]['name'] +
                            '</h2>' +
                            '<p>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0].company +
                            '<br>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0].position +
                            '</p>' +
                            '</div>'

                          tr_str_kc += '</a>'
                        }

                        tr_str_kc += '</td>'
                      }
                      tr_str_kc += '</tr>'
                      // $("#"+days_key[i]+" .shangwu").append(tr_str_kc);
                      $('.shangwu #sw_' + days_key[i]).append(tr_str_kc)
                      // $(".course" + area_id + obj.data.datas[days_key[i]]["am"][nodes_key[m]][n].courseId)
                      // 增加onclick代替a href
                      // console.log(tr_str_kc);
                      // 第三层循环 时间点内容填充 --结束
                    }
                    // 第二层循环B上午 时间点循环 --结束

                    // 追加上午的div end************
                    $('#' + days_key[i]).append('</table></div>')

                    // 第二层循环A上午 填充标题操作 --结束
                  }

                  // 如果有下午  则开始下午处理
                  if (has_pm) {
                    // 追加下午的div start************
                    // $("#"+days_key[i]).append('<div class="xiawu">');
                    $('#' + days_key[i]).append(
                      '<div class="xiawu"> <table class="title" id="xw_' +
                        days_key[i] +
                        '" >'
                    )

                    // 第二层循环A下午 填充标题操作 --开始
                    var tr_str =
                      '<tr class="top"><td><img src="../../static/images/sch_time.png"/></td>'
                    for (var j = 1; j <= apms_nums; j++) {
                      var fpstr = obj.data.finishing[days_key[i]][j + 'pm'].producers
                      var pstr = (fpstr && fpstr !== '' && fpstr != null) ? fpstr : ''
                      tr_str +=
                        '<td><img src="../../static/images/richeng/rc_0' +
                        j +
                        '.png" class="rc_img" /><h2>' +
                        obj.data.finishing[days_key[i]][j + 'pm'].name +
                        '<br>' + pstr +
                        '</h2></td>'
                    }
                    // 第二层循环A下午 填充标题操作 --结束
                    tr_str += '</tr>'
                    $('.xiawu #xw_' + days_key[i]).append(tr_str)
                    // 计算下午的时间点个数
                    nodes_key = Object.keys(obj.data.datas[days_key[i]]['pm'])
                    nodes_nums = nodes_key.length
                    // console.log(nodes_key, nodes_nums);
                    // 第二层循环B下午 时间点循环 --开始
                    // console.log("下午时间点循环 ",i,nodes_nums,apms_nums,obj.data.datas[days_key[i]]['pm']);
                    // 2021 天津 2690 过滤第二日下午第二场的数据
                    // 2021 北京 2721 过滤第二日下午第二场的数据
                    if (i === days_key.length - 1 && nodes_nums > 1 && (area_id === '2690' || area_id === '2721'))
                      nodes_nums = nodes_nums - 1
                    for (var m = 0; m < nodes_nums; m++) {
                      // 如果全部是敬请期待 跳出循环
                      var break_mark = true
                      for (var n = 1; n <= apms_nums; n++) {
                        if (
                          typeof obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n] !== 'undefined'
                        ) {
                          break_mark = false
                        }
                      }
                      // if (break_mark) break;

                      var tr_str_kc =
                        '<tr class="kecheng">' +
                        '<td><b>' +
                        _this.global.formatTime(days_key[i], 'Y/M/D') +
                        getWeek(new Date(_this.global.formatTime(days_key[i], 'Y/M/D'))) +
                        '</b><br><br>' +
                        obj.data.datas[days_key[i]]['pm'][nodes_key[m]]['time'][0] +
                        '<br>-<br>' +
                        obj.data.datas[days_key[i]]['pm'][nodes_key[m]]['time'][1] +
                        '</td>'

                      // 当前时间点的操作****************
                      // console.log(nodes_key[m]);
                      // 第三层循环 时间点内容填充 --开始
                      for (var n = 1; n <= apms_nums; n++) {
                        //* *************
                        tr_str_kc += '<td valign="top">'
                        if (
                          typeof obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n] === 'undefined'
                        ) {
                          // console.log('敬请期待');
                          // courseClassNum ++;
                          courseList.push({})
                          // console.log(courseClassNum,courseList);
                          tr_str_kc +=
                            '<div style="line-height: 180px;text-align: center;">敬请期待</div>'
                        } else {
                          // console.log(obj.data.datas[days_key[i]]['pm'][nodes_key[m]]);
                          // courseTitle
                          courseClass = 'course' + area_id + obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].courseId
                          // courseClassNum ++;
                          courseList.push({class: courseClass, aid: area_id, id: obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].courseId})
                          // console.log(courseClass,courseClassNum,courseList);
                          tr_str_kc +=
                            '<a class="' + courseClass + '"' +
                            // ' href="/course?id=' +
                            // obj.data.datas[days_key[i]]["pm"][nodes_key[m]][n].courseId +
                            // "&sid=" + area_id + '"' +
                            '>' +
                            '<div class="biaoti">' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .courseTitle +
                            '</div>' +
                            '<!-- <div class="img">' +
                            '<img src="../../static/images/anli_logo.png"/>' +
                            '</div> -->'

                          var lecturers_key = Object.keys(
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers
                          )
                          // console.log('*******');
                          lecturers_nums =
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers.length

                          // 展示下午一堂课的讲师第一人
                          tr_str_kc +=
                            '<div class="ren">' +
                            '<h2>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0]['name'] +
                            '</h2>' +
                            '<p>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0].company +
                            '<br>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0].position +
                            '</p>' +
                            '</div>'

                          // 展示下午一堂课的全部讲师
                          /* for(var z=0;z< lecturers_nums;z++){
                            tr_str_kc+='<div class="ren">'+
                            '<h2>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z]['name']+
                            '</h2>'+
                            '<p>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z].company+'<br>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z].position+'</p>'+
                            '</div>';
                          } */

                          tr_str_kc += '</a>'
                        }

                        tr_str_kc += '</td>'
                      }
                      tr_str_kc += '</tr>'
                      $('.xiawu #xw_' + days_key[i]).append(tr_str_kc)
                      // 增加onclick代替a href代替a href
                      // 第三层循环 时间点内容填充 --结束
                    }
                    // 第二层循环B下午 时间点循环 --结束

                    // 追加下午的div end************
                    $('#' + days_key[i]).append('</table></div>')
                  }

                  var li_end = '</table></li>'
                  $('.content').append(li_end)
                }

                // 添加a路由跳转
                // console.log("schedule courseList ",courseList);
                courseList.forEach(function (x, i, a) {
                  // console.log("forEach ",courseList[i],$("."+courseList[i].class))
                  if (courseList[i].class) {
                    $('.' + courseList[i].class)[0].onclick = () => {
                      _this.$router.push({path: '/course', name: 'Course', query: {sid: courseList[i].aid, id: courseList[i].id}})
                    }
                  }
                })
              } // 判断是pc结束
              else {
                // mobile开始
                // console.log('now is mobile');
                // console.log(obj);
                // 拿出第一天的所有上下午标题键

                days_key = Object.keys(obj.data.finishing)
                // console.log(days_key[0]);
                // 判断第一天是否有上午下午键 作为一个对象
                apms_key = Object.keys(obj.data.finishing[days_key[0]])
                apms_nums = apms_key.length
                // console.log(apms_key);

                // 判断上下午 计算出标题长度
                var has_am = false
                var has_pm = false
                apms_str = JSON.stringify(apms_key)
                // console.log(apms_key);
                // console.log(apms_str);
                // 判断是否有上午
                if (apms_str.indexOf('am') !== -1) {
                  has_am = true
                }
                // 判断是否有下午
                if (apms_str.indexOf('pm') !== -1) {
                  has_pm = true
                }

                // 根绝上下午判断循环次数
                if (has_am && has_pm) {
                  apms_nums = apms_nums / 2
                }
                // 截止到此 标题总长度  apms_nums

                var apm_pre = 'am'
                if (!has_am && has_pm) {
                  apm_pre = 'pm'
                }

                // 取到所有标题
                for (var a = 1; a <= apms_nums; a++) {
                  $('.sch_p').text(
                    _this.global.formatTime(days_key[0], 'Y.M.D') +
                      '~' +
                      _this.global.formatTime(days_key[1], 'Y.M.D') +
                      '\xa0\xa0\xa0\xa0'
                  )
                  // $(".sch_p").text("时间："+_this.global.formatTime(days_key[0],"Y.M.D")+"~"+_this.global.formatTime(days_key[1],"Y.M.D")+"\xa0\xa0\xa0\xa0"+"地点："+config[area_id].title)
                  // <li class="col-xs-6 col-sm-6">产品创新/体验设计</li>
                  var li_str =
                    '<li class="col-xs-6 col-sm-6"  id="' +
                    obj.data.finishing[days_key[0]][a + apm_pre].groupId +
                    '" >' +
                    obj.data.finishing[days_key[0]][a + apm_pre]['name'] +
                    '</li>'
                  $('.wap_daohang').append(li_str)
                  // console.log(obj.data.finishing[days_key[0]][a+apm_pre]);
                }

                var con_keys = Object.keys(obj.data.datas)

                // 主标题的点击事件_开始
                $('.wap_daohang li').click(function () {
                  // 获取本课程的id
                  var groupId = $(this).attr('id')
                  $('.wap_content').html('')

                  var con_str = '<li  class="show">'
                  // 循环每一天
                  //
                  let courseClassNum = 0
                  let courseClass = ''
                  let courseList = []
                  for (var b = 0; b < con_keys.length; b++) {
                    // console.log(con_keys[b]);
                    con_str +=
                      '<h6>' +
                      _this.global.formatTime(con_keys[b], 'Y/M/D') +
                      ' ' +
                      getWeek(new Date(_this.global.formatTime(con_keys[b], 'Y/M/D'))) +
                      '</h6>'
                    con_str +=
                      '<div class="rad row" id="' + con_keys[b] + '" >'

                    // con_keys[b]
                    var one_keys = Object.keys(obj.data.datas[con_keys[b]])
                    // 循环上下午
                    for (var d = 0; d < one_keys.length; d++) {
                      // console.log(one_keys[d]);
                      // console.log(obj.data.datas[con_keys[b]][one_keys[d]])
                      var hour_keys = Object.keys(
                        obj.data.datas[con_keys[b]][one_keys[d]]
                      )
                      // 上下午内时间点循环
                      for (let e = 0; e < hour_keys.length; e++) {
                        var x_keys = Object.keys(
                          obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]
                        )
                        // console.log(x_keys);
                        for (let f = 0; f < x_keys.length; f++) {
                          // 判断是否为当前课程的id
                          // console.log(x_keys[f]+'   '+groupId);
                          if (x_keys[f].toString() === groupId.toString()) {
                            // /
                            courseClassNum++
                            courseClass = 'course_' + area_id + obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].courseId
                            courseList.push({class: courseClass, aid: area_id, id: obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].courseId})
                            con_str +=
                              '<div class="col-sm-12 col-xs-12">' +
                              '<a class="' + courseClass + '"' +
                              // ' href="/course?id=' +
                              // obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].courseId +
                              // "&sid=" + area_id + '"' +
                              '>' +
                              '<h2> ' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].courseTitle +
                              '</h2>' +
                              '<div>' +
                              '<div class="img">' +
                              '<img src="../../static/images/anli_logo.png" width="100%" />' +
                              '</div>' +
                              '<div class="wenz">' +
                              '<p>' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].name +
                              '<span>' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].company +
                              '' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].position +
                              '</span>' +
                              '</p>' +
                              '<span class="glyphicon glyphicon-time title_time"></span>' +
                              '<span class="time">' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]['time'][0] +
                              '~' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]['time'][1] +
                              '</span>' +
                              '</div>' +
                              '</div>' +
                              '</a>' +
                              '</div>'
                            // /
                          }
                        }
                      }
                    }

                    // for(var c=0;c)

                    con_str += '</div>'
                  }
                  con_str += '</li>'
                  $('.wap_content').html(con_str)
                  // 增加onclick代替a href
                  // console.log(courseClassNum,courseClass,courseList);
                  // console.log("schedule courseList ",courseList);
                  courseList.forEach(function (x, i, a) {
                    // console.log($("."+courseList[i].class))
                    if (courseList[i].class) {
                      $('.' + courseList[i].class)[0].onclick = () => {
                        _this.$router.push({path: '/course', name: 'Course', query: {sid: courseList[i].aid, id: courseList[i].id}})
                      }
                    }
                  })
                }) /// /主标题的点击事件 --结束
                // 默认执行一次第一个按钮的点击事件
                var project = ''
                if (_this.getQueryString('project') != null) {
                  project = _this.getQueryString('project')
                  if (project.toString() === '1') {
                    $('.wap_daohang #1').css({
                      'background': '#0299d7',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #2a75bb',
                      'color': '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][1 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '2') {
                    $('.wap_daohang #2').css({
                      background: '#ea078e',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #da0082',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][2 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '3') {
                    $('.wap_daohang #3').css({
                      background: '#ffae0d',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #ffae0d',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][3 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '4') {
                    $('.wap_daohang #4').css({
                      background: '#11aa48',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #019235',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][4 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '5') {
                    $('.wap_daohang #5').css({
                      background: '#9e9e9f',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #9e9e9f',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][5 + apm_pre]['groupId']
                    ).click()
                  }
                } else {
                  $(
                    '#' +
                      obj.data.finishing[days_key[0]][1 + apm_pre]['groupId']
                  ).click()
                }
              } // mobile结束
              // 最外层按照日程 第一层循环 ---开始
              /// /////////////////////////////////////////////
            } else {
              console.log('请求错误')
            }
          }
        })
      } else if (area_id === '2252') {
        // 只用于2020mpd成都站
        $.ajax({
          type: 'get',
          url: url_schedule,
          dataType: 'jsonp',
          success: function (obj) {
            // console.log("2252 ",obj);
            if (obj.errno && obj.errno.toString() === '0') {
              // document.title = '工作坊日程—第' + config[area_id].jieshu + '届 MPD工作坊' + config[area_id].title + '站';

              $('.sch_h1').text(_this.global.config[area_id].title)
              $('.sch_p1').text(_this.global.config[area_id].trueplace)
              // $(".sch_h1").text(config[area_id].title+'-'+config[area_id].trueplace);
              $('.sch_wap_h1').text(
                _this.global.config[area_id].year +
                  _this.global.config[area_id].title +
                  '站MPD日程'
              )
              // 判断是否为pc
              if (IsPC()) {
                /// /////////////////////////////////////////////
                // 根据obj.data.finishing的元素个数算出天数
                var days_key = Object.keys(obj.data.finishing)
                // console.log(days_key);return false;
                // console.log(days_key.length);
                // 最外层按照日程 第一层循环 ---开始
                for (var i = 0; i < days_key.length; i++) {
                  // 处理天的操作**********写日期大标题
                  // console.log(days_key[1]);
                  // var li_pre ='<li class="show"><table class="title" id="'+days_key[i]+'">';****
                  $('.sch_p').text(
                    _this.global.formatTime(days_key[0], 'Y.M.D') +
                      '~' +
                      _this.global.formatTime(days_key[1], 'D')
                  )
                  var li_pre =
                    '<h1>' +
                    _this.global.formatTime(days_key[i], 'Y年M月D日') +
                    '</h1>' +
                    '<li class="show" id="' +
                    days_key[i] +
                    '">'
                  $('.content').append(li_pre)

                  // 计算每一天内上下午总个数
                  var apms_key = Object.keys(obj.data.finishing[days_key[i]])
                  var apms_nums = apms_key.length
                  // console.log(apms_nums);

                  // 判断上下午
                  var has_am = false
                  var has_pm = false
                  var apms_str = JSON.stringify(apms_key)
                  // console.log(apms_key);
                  // console.log(apms_str);
                  // 判断是否有上午
                  if (apms_str.indexOf('am') !== -1) {
                    has_am = true
                  }
                  // 判断是否有下午
                  if (apms_str.indexOf('pm') !== -1) {
                    has_pm = true
                  }

                  // var j=apms_nums;
                  // 根绝上下午判断循环次数
                  if (has_am && has_pm) {
                    apms_nums = apms_nums / 2
                  }

                  // 如果有上午  则开始上午处理
                  if (has_am) {
                    // 追加上午的div start************
                    $('#' + days_key[i]).append(
                      '<div class="shangwu"> <table class="title" id="sw_' +
                        days_key[i] +
                        '" >'
                    )
                    // console.log(obj.data.finishing[days_key[i]][j+'am'])
                    // 第二层循环A上午 填充标题操作 --开始
                    var tr_str =
                      '<tr class="top"><td><img src="../../static/images/sch_time.png"/></td>'
                    for (var j = 1; j <= apms_nums; j++) {
                      var fpstr = obj.data.finishing[days_key[i]][j + 'am'].producers
                      var pstr = (fpstr && fpstr !== '' && fpstr != null) ? fpstr : ''
                      if (j === 4) {
                        tr_str +=
                          '<td style="background:#9e9e9f"><img src="../../static/images/richeng/rc_0' +
                          5 +
                          '.png" class="rc_img" /><h2>' +
                          obj.data.finishing[days_key[i]][j + 'am'].name +
                          '<br>' +
                          pstr +
                          '</h2></td>'
                      } else {
                        tr_str +=
                          '<td><img src="../../static/images/richeng/rc_0' +
                          j +
                          '.png" class="rc_img" /><h2>' +
                          obj.data.finishing[days_key[i]][j + 'am'].name +
                          '<br>' +
                          pstr +
                          '</h2></td>'
                      }
                      // 上午标题操作****头像也在此处理************
                      // $(".content .title .shangwu .top").append('<td><img src="images/richeng/rc_01.png" class="rc_img" /></td>');
                      // console.log(obj.data.finishing[days_key[i]][j+'am'].name);
                      // console.log(obj.data.finishing[days_key[i]][j+'am'].producers);
                    }
                    // 第二层循环A上午 填充标题操作 --结束
                    tr_str += '</tr>'
                    $('.shangwu #sw_' + days_key[i]).append(tr_str)

                    // 计算上午的时间点个数
                    var nodes_key = Object.keys(
                      obj.data.datas[days_key[i]]['am']
                    )
                    var nodes_nums = nodes_key.length
                    // console.log(nodes_nums);
                    // 第二层循环B上午 时间点循环 --开始
                    // console.log(obj.data.datas[days_key[i]]['am']);

                    for (var m = 0; m < nodes_nums; m++) {
                      var tr_str_kc =
                        '<tr class="kecheng">' +
                        '<td><b>' +
                        _this.global.formatTime(days_key[i], 'Y/M/D') +
                        getWeek(new Date(_this.global.formatTime(days_key[i], 'Y/M/D'))) +
                        '</b><br><br>' +
                        obj.data.datas[days_key[i]]['am'][nodes_key[m]]['time'][0] +
                        '<br>-<br>' +
                        obj.data.datas[days_key[i]]['am'][nodes_key[m]]['time'][1] +
                        '</td>'

                      // 当前时间点的操作****************
                      // console.log(nodes_key[m]);
                      // 第三层循环 时间点内容填充 --开始
                      // console.log(obj.data.datas[days_key[i]]['am'][nodes_key[m]]);
                      for (var n = 1; n <= apms_nums; n++) {
                        //* *************
                        tr_str_kc += '<td valign="top">'
                        if (
                          typeof obj.data.datas[days_key[i]]['am'][nodes_key[m]][n] === 'undefined'
                        ) {
                          // console.log('敬请期待');
                          tr_str_kc +=
                            '<div style="line-height: 180px;text-align: center;">敬请期待</div>'
                        } else {
                          // console.log(obj.data.datas[days_key[i]]['am'][nodes_key[m]]);
                          // courseTitle
                          tr_str_kc +=
                            '<a href="/course?id=' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .courseId +
                            '&sid=' +
                            area_id +
                            '">' +
                            '<div class="biaoti">' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .courseTitle +
                            '</div>' +
                            '<!-- <div class="img">' +
                            '<img src="../../static/images/anli_logo.png"/>' +
                            '</div> -->'

                          var lecturers_key = Object.keys(
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers
                          )

                          var lecturers_nums =
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers.length

                          // 上午展示一堂课的讲师第一个人
                          tr_str_kc +=
                            '<div class="ren">' +
                            '<h2>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0]['name'] +
                            '</h2>' +
                            '<p>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0].company +
                            '<br>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0].position +
                            '</p>' +
                            '</div>'

                          // 上午展示一堂课的讲师全部
                          /* for(var z=0;z< lecturers_nums;z++){
                            tr_str_kc+='<div class="ren">'+
                            '<h2>'+
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n].lecturers[z]['name']+
                            '</h2>'+
                            '<p>'+
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n].lecturers[z].company+'<br>'+
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n].lecturers[z].position+'</p>'+
                            '</div>';
                          } */

                          tr_str_kc += '</a>'
                        }

                        tr_str_kc += '</td>'
                      }
                      tr_str_kc += '</tr>'
                      // $("#"+days_key[i]+" .shangwu").append(tr_str_kc);
                      $('.shangwu #sw_' + days_key[i]).append(tr_str_kc)
                      // console.log(tr_str_kc);
                      // 第三层循环 时间点内容填充 --结束
                    }
                    // 第二层循环B上午 时间点循环 --结束

                    // 追加上午的div end************
                    $('#' + days_key[i]).append('</table></div>')

                    // 第二层循环A上午 填充标题操作 --结束
                  }

                  // 如果有下午  则开始下午处理
                  if (has_pm) {
                    // 追加下午的div start************
                    // $("#"+days_key[i]).append('<div class="xiawu">');
                    $('#' + days_key[i]).append(
                      '<div class="xiawu"> <table class="title" id="xw_' +
                        days_key[i] +
                        '" >'
                    )

                    // 第二层循环A下午 填充标题操作 --开始
                    var tr_str =
                      '<tr class="top"><td><img src="../../static/images/sch_time.png"/></td>'
                    for (var j = 1; j <= apms_nums; j++) {
                      var fpstr = obj.data.finishing[days_key[i]][j + 'pm'].producers
                      var pstr = (fpstr && fpstr !== '' && fpstr != null) ? fpstr : ''
                      if (j === 4) {
                        tr_str +=
                          '<td style="background:#9e9e9f"><img src="../../static/images/richeng/rc_0' +
                          5 +
                          '.png" class="rc_img" /><h2>' +
                          obj.data.finishing[days_key[i]][j + 'pm'].name +
                          '<br>' +
                          pstr +
                          '</h2></td>'
                      } else {
                        tr_str +=
                          '<td><img src="../../static/images/richeng/rc_0' +
                          j +
                          '.png" class="rc_img" /><h2>' +
                          obj.data.finishing[days_key[i]][j + 'pm'].name +
                          '<br>' +
                          pstr +
                          '</h2></td>'
                      }
                    }
                    // 第二层循环A下午 填充标题操作 --结束
                    tr_str += '</tr>'
                    $('.xiawu #xw_' + days_key[i]).append(tr_str)
                    // 计算下午的时间点个数
                    nodes_key = Object.keys(obj.data.datas[days_key[i]]['pm'])
                    nodes_nums = nodes_key.length
                    // console.log(nodes_key);
                    // console.log(nodes_nums);
                    // 第二层循环B下午 时间点循环 --开始
                    // console.log(obj.data.datas[days_key[i]]['pm']);
                    for (var m = 0; m < nodes_nums; m++) {
                      // 如果全部是敬请期待 跳出循环
                      var break_mark = true
                      for (var n = 1; n <= apms_nums; n++) {
                        if (
                          typeof obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n] !== 'undefined'
                        ) {
                          break_mark = false
                        }
                      }
                      // if (break_mark) break;

                      var tr_str_kc =
                        '<tr class="kecheng">' +
                        '<td><b>' +
                        _this.global.formatTime(days_key[i], 'Y/M/D') +
                        getWeek(new Date(_this.global.formatTime(days_key[i], 'Y/M/D'))) +
                        '</b><br><br>' +
                        obj.data.datas[days_key[i]]['pm'][nodes_key[m]]['time'][0] +
                        '<br>-<br>' +
                        obj.data.datas[days_key[i]]['pm'][nodes_key[m]]['time'][1] +
                        '</td>'

                      // 当前时间点的操作****************
                      // console.log(nodes_key[m]);
                      // 第三层循环 时间点内容填充 --开始
                      for (var n = 1; n <= apms_nums; n++) {
                        //* *************
                        tr_str_kc += '<td valign="top">'
                        if (
                          typeof obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n] === 'undefined'
                        ) {
                          // console.log('敬请期待');
                          tr_str_kc +=
                            '<div style="line-height: 180px;text-align: center;">敬请期待</div>'
                        } else {
                          // console.log(obj.data.datas[days_key[i]]['pm'][nodes_key[m]]);
                          // courseTitle
                          tr_str_kc +=
                            '<a href="/course?id=' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .courseId +
                            '&sid=' +
                            area_id +
                            '">' +
                            '<div class="biaoti">' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .courseTitle +
                            '</div>' +
                            '<!-- <div class="img">' +
                            '<img src="../../static/images/anli_logo.png"/>' +
                            '</div> -->'

                          var lecturers_key = Object.keys(
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers
                          )
                          // console.log('*******');
                          lecturers_nums =
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers.length

                          // 展示下午一堂课的讲师第一人
                          tr_str_kc +=
                            '<div class="ren">' +
                            '<h2>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0]['name'] +
                            '</h2>' +
                            '<p>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0].company +
                            '<br>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0].position +
                            '</p>' +
                            '</div>'

                          // 展示下午一堂课的全部讲师
                          /* for(var z=0;z< lecturers_nums;z++){
                            tr_str_kc+='<div class="ren">'+
                            '<h2>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z]['name']+
                            '</h2>'+
                            '<p>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z].company+'<br>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z].position+'</p>'+
                            '</div>';
                          } */

                          tr_str_kc += '</a>'
                        }

                        tr_str_kc += '</td>'
                      }
                      tr_str_kc += '</tr>'
                      $('.xiawu #xw_' + days_key[i]).append(tr_str_kc)
                      // 第三层循环 时间点内容填充 --结束
                    }
                    // 第二层循环B下午 时间点循环 --结束

                    // 追加下午的div end************
                    $('#' + days_key[i]).append('</table></div>')
                  }

                  var li_end = '</table></li>'
                  $('.content').append(li_end)
                }
              } else {
                // mobile开始
                days_key = Object.keys(obj.data.finishing)
                // console.log(days_key[0]);
                // 判断第一天是否有上午下午键 作为一个对象
                apms_key = Object.keys(obj.data.finishing[days_key[0]])
                apms_nums = apms_key.length
                // console.log(apms_key);

                // 判断上下午 计算出标题长度
                var has_am = false
                var has_pm = false
                apms_str = JSON.stringify(apms_key)
                // console.log(apms_key);
                // console.log(apms_str);
                // 判断是否有上午
                if (apms_str.indexOf('am') !== -1) {
                  has_am = true
                }
                // 判断是否有下午
                if (apms_str.indexOf('pm') !== -1) {
                  has_pm = true
                }

                // 根绝上下午判断循环次数
                if (has_am && has_pm) {
                  apms_nums = apms_nums / 2
                }
                // 截止到此 标题总长度  apms_nums

                var apm_pre = 'am'
                if (!has_am && has_pm) {
                  apm_pre = 'pm'
                }

                // 取到所有标题
                for (var a = 1; a <= apms_nums; a++) {
                  // console.log(a);
                  if (a === 4) {
                    // 测试管理为灰色
                    $('.sch_p').text(
                      _this.global.formatTime(days_key[0], 'Y.M.D') +
                        '~' +
                        _this.global.formatTime(days_key[1], 'Y.M.D') +
                        '\xa0\xa0\xa0\xa0'
                    )
                    // $(".sch_p").text("时间："+_this.global.formatTime(days_key[0],"Y.M.D")+"~"+_this.global.formatTime(days_key[1],"Y.M.D")+"\xa0\xa0\xa0\xa0"+"地点："+config[area_id].title)
                    // <li class="col-xs-6 col-sm-6">产品创新/体验设计</li>
                    var li_str =
                      '<li class="col-xs-6 col-sm-6 test-manage"  id="' +
                      obj.data.finishing[days_key[0]][a + apm_pre].groupId +
                      '" >' +
                      obj.data.finishing[days_key[0]][a + apm_pre]['name'] +
                      '</li>'
                  } else {
                    $('.sch_p').text(
                      _this.global.formatTime(days_key[0], 'Y.M.D') +
                        '~' +
                        _this.global.formatTime(days_key[1], 'Y.M.D') +
                        '\xa0\xa0\xa0\xa0'
                    )
                    // $(".sch_p").text("时间："+_this.global.formatTime(days_key[0],"Y.M.D")+"~"+_this.global.formatTime(days_key[1],"Y.M.D")+"\xa0\xa0\xa0\xa0"+"地点："+config[area_id].title)
                    // <li class="col-xs-6 col-sm-6">产品创新/体验设计</li>
                    var li_str =
                      '<li class="col-xs-6 col-sm-6"  id="' +
                      obj.data.finishing[days_key[0]][a + apm_pre].groupId +
                      '" >' +
                      obj.data.finishing[days_key[0]][a + apm_pre]['name'] +
                      '</li>'
                    // console.log("obj.data.finishing[days_key[0]][a + apm_pre][] ",obj.data.finishing[days_key[0]][a + apm_pre]["name"]);
                  }
                  $('.wap_daohang').append(li_str)
                }

                var con_keys = Object.keys(obj.data.datas)

                // 主标题的点击事件_开始
                $('.wap_daohang li').click(function () {
                  // 获取本课程的id
                  var groupId = $(this).attr('id')
                  $('.wap_content').html('')

                  var con_str = '<li  class="show">'
                  // 循环每一天
                  for (var b = 0; b < con_keys.length; b++) {
                    // console.log(con_keys[b]);
                    con_str +=
                      '<h6>' +
                      _this.global.formatTime(con_keys[b], 'Y/M/D') +
                      ' ' +
                      getWeek(new Date(_this.global.formatTime(con_keys[b], 'Y/M/D'))) +
                      '</h6>'
                    con_str +=
                      '<div class="rad row" id="' + con_keys[b] + '" >'

                    // con_keys[b]
                    var one_keys = Object.keys(obj.data.datas[con_keys[b]])
                    // 循环上下午
                    for (var d = 0; d < one_keys.length; d++) {
                      // console.log(one_keys[d]);
                      // console.log(obj.data.datas[con_keys[b]][one_keys[d]])
                      var hour_keys = Object.keys(
                        obj.data.datas[con_keys[b]][one_keys[d]]
                      )
                      // 上下午内时间点循环
                      for (let e = 0; e < hour_keys.length; e++) {
                        var x_keys = Object.keys(
                          obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]
                        )
                        // console.log(x_keys);
                        for (let f = 0; f < x_keys.length; f++) {
                          // 判断是否为当前课程的id
                          // console.log(x_keys[f]+'   '+groupId);
                          if (x_keys[f].toString() === groupId.toString()) {
                            // /
                            con_str +=
                              '<div class="col-sm-12 col-xs-12">' +
                              '<a href="/course?id=' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].courseId +
                              '&sid=' +
                              area_id +
                              '">' +
                              '<h2> ' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].courseTitle +
                              '</h2>' +
                              '<div>' +
                              '<div class="img">' +
                              '<img src="../../static/images/anli_logo.png" width="100%" />' +
                              '</div>' +
                              '<div class="wenz">' +
                              '<p>' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].name +
                              '<span>' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].company +
                              '' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].position +
                              '</span>' +
                              '</p>' +
                              '<span class="glyphicon glyphicon-time title_time"></span>' +
                              '<span class="time">' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]['time'][0] +
                              '~' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]['time'][1] +
                              '</span>' +
                              '</div>' +
                              '</div>' +
                              '</a>' +
                              '</div>'
                            // /
                          }
                        }
                      }
                    }

                    // for(var c=0;c)

                    con_str += '</div>'
                  }
                  con_str += '</li>'
                  $('.wap_content').html(con_str)
                  //
                }) /// /主标题的点击事件 --结束
                // 默认执行一次第一个按钮的点击事件
                var project = ''
                if (_this.getQueryString('project') != null) {
                  project = _this.getQueryString('project')
                  if (project.toString() === '1') {
                    $('.wap_daohang #1').css({
                      background: '#0299d7',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #2a75bb',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][1 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '2') {
                    $('.wap_daohang #2').css({
                      background: '#ea078e',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #da0082',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][2 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '3') {
                    $('.wap_daohang #3').css({
                      background: '#ffae0d',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #ffae0d',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][3 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '4') {
                    $('.wap_daohang #4').css({
                      background: '#11aa48',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #019235',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][4 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '5') {
                    $('.wap_daohang #5').css({
                      background: '#9e9e9f',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #9e9e9f',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][5 + apm_pre]['groupId']
                    ).click()
                  }
                } else {
                  $(
                    '#' +
                      obj.data.finishing[days_key[0]][1 + apm_pre]['groupId']
                  ).click()
                  // console.log("obj.data.finishing[days_key[0]][1 + apm_pre]['']  ",obj.data.finishing[days_key[0]][1 + apm_pre]["groupId"])
                }
              }
            }
          }
        })
      } else if (
        area_id !== '1270' &&
        area_id !== '1058' &&
        area_id !== '1038' &&
        area_id !== '1014' &&
        parseInt(area_id) > 1000
      ) {
        // 除 2018年mpd、2020年成都mpd、2021上海天津mpd 以外
        $.ajax({
          type: 'get',
          url: url_schedule,
          dataType: 'jsonp',
          success: function (obj) {
            // console.log(obj);
            if (obj.errno && obj.errno.toString() === '0') {
              // document.title = '工作坊日程—第' + config[area_id].jieshu + '届 MPD工作坊' + config[area_id].title + '站';

              // console.log(" this.global.config ",_this.global.config);
              $('.sch_h1').text(_this.global.config[area_id].title)
              $('.sch_p1').text(_this.global.config[area_id].trueplace)
              // $(".sch_h1").text(config[area_id].title+'-'+config[area_id].trueplace);
              $('.sch_wap_h1').text(
                _this.global.config[area_id].year + _this.global.config[area_id].title + '站MPD日程'
              )
              // 判断是否为pc
              if (IsPC()) {
                /// /////////////////////////////////////////////
                // 根据obj.data.finishing的元素个数算出天数
                var days_key = Object.keys(obj.data.finishing)
                // console.log(days_key);return false;
                // console.log(days_key.length);
                // 最外层按照日程 第一层循环 ---开始
                for (var i = 0; i < days_key.length; i++) {
                  // 处理天的操作**********写日期大标题
                  // console.log(days_key[1]);
                  // var li_pre ='<li class="show"><table class="title" id="'+days_key[i]+'">';****
                  $('.sch_p').text(
                    _this.global.formatTime(days_key[0], 'Y.M.D') +
                      '~' +
                      _this.global.formatTime(days_key[1], 'D')
                  )
                  var li_pre =
                    '<h1>' +
                    _this.global.formatTime(days_key[i], 'Y年M月D日') +
                    '</h1>' +
                    '<li class="show" id="' +
                    days_key[i] +
                    '">'
                  $('.content').append(li_pre)

                  // 计算每一天内上下午总个数
                  var apms_key = Object.keys(obj.data.finishing[days_key[i]])
                  var apms_nums = apms_key.length
                  // console.log(apms_nums);

                  // 判断上下午
                  var has_am = false
                  var has_pm = false
                  var apms_str = JSON.stringify(apms_key)
                  // console.log(apms_key);
                  // console.log(apms_str);
                  // 判断是否有上午
                  if (apms_str.indexOf('am') !== -1) {
                    has_am = true
                  }
                  // 判断是否有下午
                  if (apms_str.indexOf('pm') !== -1) {
                    has_pm = true
                  }

                  // var j=apms_nums;
                  // 根绝上下午判断循环次数
                  if (has_am && has_pm) {
                    apms_nums = apms_nums / 2
                  }

                  // 如果有上午  则开始上午处理
                  if (has_am) {
                    // 追加上午的div start************
                    $('#' + days_key[i]).append(
                      '<div class="shangwu"> <table class="title" id="sw_' +
                        days_key[i] +
                        '" >'
                    )
                    // console.log(obj.data.finishing[days_key[i]][j+'am'])
                    // 第二层循环A上午 填充标题操作 --开始
                    var tr_str =
                      '<tr class="top"><td><img src="../../static/images/sch_time.png"/></td>'
                    for (var j = 1; j <= apms_nums; j++) {
                      var fpstr = obj.data.finishing[days_key[i]][j + 'am'].producers
                      var pstr = (fpstr && fpstr !== '' && fpstr != null) ? fpstr : ''
                      tr_str +=
                        '<td><img src="../../static/images/richeng/rc_0' +
                        j +
                        '.png" class="rc_img" /><h2>' +
                        obj.data.finishing[days_key[i]][j + 'am'].name +
                        '<br>' +
                        pstr +
                        '</h2></td>'
                      // 上午标题操作****头像也在此处理************
                      // $(".content .title .shangwu .top").append('<td><img src="images/richeng/rc_01.png" class="rc_img" /></td>');
                      // console.log(obj.data.finishing[days_key[i]][j+'am'].name);
                      // console.log(obj.data.finishing[days_key[i]][j+'am'].producers);
                    }
                    // 第二层循环A上午 填充标题操作 --结束
                    tr_str += '</tr>'
                    $('.shangwu #sw_' + days_key[i]).append(tr_str)

                    // 计算上午的时间点个数
                    var nodes_key = Object.keys(obj.data.datas[days_key[i]]['am'])
                    var nodes_nums = nodes_key.length
                    // console.log(nodes_nums);
                    // 第二层循环B上午 时间点循环 --开始
                    // console.log(obj.data.datas[days_key[i]]['am']);

                    for (var m = 0; m < nodes_nums; m++) {
                      var tr_str_kc =
                        '<tr class="kecheng">' +
                        '<td><b>' +
                        _this.global.formatTime(days_key[i], 'Y/M/D') +
                        getWeek(new Date(_this.global.formatTime(days_key[i], 'Y/M/D'))) +
                        '</b><br><br>' +
                        obj.data.datas[days_key[i]]['am'][nodes_key[m]]['time'][0] +
                        '<br>-<br>' +
                        obj.data.datas[days_key[i]]['am'][nodes_key[m]]['time'][1] +
                        '</td>'

                      // 当前时间点的操作****************
                      // console.log(nodes_key[m]);
                      // 第三层循环 时间点内容填充 --开始
                      // console.log(obj.data.datas[days_key[i]]['am'][nodes_key[m]]);
                      for (var n = 1; n <= apms_nums; n++) {
                        //* *************
                        tr_str_kc += '<td valign="top">'
                        if (
                          typeof obj.data.datas[days_key[i]]['am'][nodes_key[m]][n] === 'undefined'
                        ) {
                          // console.log('敬请期待');
                          tr_str_kc +=
                            '<div style="line-height: 180px;text-align: center;">敬请期待</div>'
                        } else {
                          // console.log(obj.data.datas[days_key[i]]['am'][nodes_key[m]]);
                          // courseTitle
                          tr_str_kc +=
                            '<a href="/course?id=' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .courseId +
                            '&sid=' +
                            area_id +
                            '">' +
                            '<div class="biaoti">' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .courseTitle +
                            '</div>' +
                            '<!-- <div class="img">' +
                            '<img src="../../static/images/anli_logo.png"/>' +
                            '</div> -->'

                          var lecturers_key = Object.keys(
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers
                          )

                          var lecturers_nums =
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers.length

                          // 上午展示一堂课的讲师第一个人
                          tr_str_kc +=
                            '<div class="ren">' +
                            '<h2>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0]['name'] +
                            '</h2>' +
                            '<p>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0].company +
                            '<br>' +
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n]
                              .lecturers[0].position +
                            '</p>' +
                            '</div>'

                          // 上午展示一堂课的讲师全部
                          /* for(var z=0;z< lecturers_nums;z++){
                            tr_str_kc+='<div class="ren">'+
                            '<h2>'+
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n].lecturers[z]['name']+
                            '</h2>'+
                            '<p>'+
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n].lecturers[z].company+'<br>'+
                            obj.data.datas[days_key[i]]['am'][nodes_key[m]][n].lecturers[z].position+'</p>'+
                            '</div>';
                          } */

                          tr_str_kc += '</a>'
                        }

                        tr_str_kc += '</td>'
                      }
                      tr_str_kc += '</tr>'
                      // $("#"+days_key[i]+" .shangwu").append(tr_str_kc);
                      $('.shangwu #sw_' + days_key[i]).append(tr_str_kc)
                      // console.log(tr_str_kc);
                      // 第三层循环 时间点内容填充 --结束
                    }
                    // 第二层循环B上午 时间点循环 --结束

                    // 追加上午的div end************
                    $('#' + days_key[i]).append('</table></div>')

                    // 第二层循环A上午 填充标题操作 --结束
                  }

                  // 如果有下午  则开始下午处理
                  if (has_pm) {
                    // 追加下午的div start************
                    // $("#"+days_key[i]).append('<div class="xiawu">');
                    $('#' + days_key[i]).append(
                      '<div class="xiawu"> <table class="title" id="xw_' +
                        days_key[i] +
                        '" >'
                    )

                    // 第二层循环A下午 填充标题操作 --开始
                    var tr_str =
                      '<tr class="top"><td><img src="../../static/images/sch_time.png"/></td>'
                    for (var j = 1; j <= apms_nums; j++) {
                      var fpstr = obj.data.finishing[days_key[i]][j + 'pm'].producers
                      var pstr = (fpstr && fpstr !== '' && fpstr != null) ? fpstr : ''
                      tr_str +=
                        '<td><img src="../../static/images/richeng/rc_0' +
                        j +
                        '.png" class="rc_img" /><h2>' +
                        obj.data.finishing[days_key[i]][j + 'pm'].name +
                        '<br>' +
                        pstr +
                        '</h2></td>'
                    }
                    // 第二层循环A下午 填充标题操作 --结束
                    tr_str += '</tr>'
                    $('.xiawu #xw_' + days_key[i]).append(tr_str)
                    // 计算下午的时间点个数
                    nodes_key = Object.keys(obj.data.datas[days_key[i]]['pm'])
                    nodes_nums = nodes_key.length
                    // console.log(nodes_key);
                    // console.log(nodes_nums);
                    // 第二层循环B下午 时间点循环 --开始
                    // console.log(obj.data.datas[days_key[i]]['pm']);
                    for (var m = 0; m < nodes_nums; m++) {
                      // 如果全部是敬请期待 跳出循环
                      var break_mark = true
                      for (var n = 1; n <= apms_nums; n++) {
                        if (
                          typeof obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n] !== 'undefined'
                        ) {
                          break_mark = false
                        }
                      }
                      // if (break_mark) break;

                      var tr_str_kc =
                        '<tr class="kecheng">' +
                        '<td><b>' +
                        _this.global.formatTime(days_key[i], 'Y/M/D') +
                        getWeek(new Date(_this.global.formatTime(days_key[i], 'Y/M/D'))) +
                        '</b><br><br>' +
                        obj.data.datas[days_key[i]]['pm'][nodes_key[m]]['time'][0] +
                        '<br>-<br>' +
                        obj.data.datas[days_key[i]]['pm'][nodes_key[m]]['time'][1] +
                        '</td>'

                      // 当前时间点的操作****************
                      // console.log(nodes_key[m]);
                      // 第三层循环 时间点内容填充 --开始
                      for (var n = 1; n <= apms_nums; n++) {
                        //* *************
                        tr_str_kc += '<td valign="top">'
                        if (
                          typeof obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n] === 'undefined'
                        ) {
                          // console.log('敬请期待');
                          tr_str_kc +=
                            '<div style="line-height: 180px;text-align: center;">敬请期待</div>'
                        } else {
                          // console.log(obj.data.datas[days_key[i]]['pm'][nodes_key[m]]);
                          // courseTitle
                          tr_str_kc +=
                            '<a href="/course?id=' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .courseId +
                            '&sid=' +
                            area_id +
                            '">' +
                            '<div class="biaoti">' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .courseTitle +
                            '</div>' +
                            '<!-- <div class="img">' +
                            '<img src="../../static/images/anli_logo.png"/>' +
                            '</div> -->'

                          var lecturers_key = Object.keys(
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers
                          )
                          // console.log('*******');
                          lecturers_nums =
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers.length

                          // 展示下午一堂课的讲师第一人
                          tr_str_kc +=
                            '<div class="ren">' +
                            '<h2>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0]['name'] +
                            '</h2>' +
                            '<p>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0].company +
                            '<br>' +
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n]
                              .lecturers[0].position +
                            '</p>' +
                            '</div>'

                          // 展示下午一堂课的全部讲师
                          /* for(var z=0;z< lecturers_nums;z++){
                            tr_str_kc+='<div class="ren">'+
                            '<h2>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z]['name']+
                            '</h2>'+
                            '<p>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z].company+'<br>'+
                            obj.data.datas[days_key[i]]['pm'][nodes_key[m]][n].lecturers[z].position+'</p>'+
                            '</div>';
                          } */

                          tr_str_kc += '</a>'
                        }

                        tr_str_kc += '</td>'
                      }
                      tr_str_kc += '</tr>'
                      $('.xiawu #xw_' + days_key[i]).append(tr_str_kc)
                      // 第三层循环 时间点内容填充 --结束
                    }
                    // 第二层循环B下午 时间点循环 --结束

                    // 追加下午的div end************
                    $('#' + days_key[i]).append('</table></div>')
                  }

                  var li_end = '</table></li>'
                  $('.content').append(li_end)
                }
              } // 判断是pc结束
              else {
                // mobile开始
                // console.log('now is mobile');
                // console.log(obj);
                // 拿出第一天的所有上下午标题键

                days_key = Object.keys(obj.data.finishing)
                // console.log(days_key[0]);
                // 判断第一天是否有上午下午键 作为一个对象
                apms_key = Object.keys(obj.data.finishing[days_key[0]])
                apms_nums = apms_key.length
                // console.log(apms_key);

                // 判断上下午 计算出标题长度
                var has_am = false
                var has_pm = false
                apms_str = JSON.stringify(apms_key)
                // console.log(apms_key);
                // console.log(apms_str);
                // 判断是否有上午
                if (apms_str.indexOf('am') !== -1) {
                  has_am = true
                }
                // 判断是否有下午
                if (apms_str.indexOf('pm') !== -1) {
                  has_pm = true
                }

                // 根绝上下午判断循环次数
                if (has_am && has_pm) {
                  apms_nums = apms_nums / 2
                }
                // 截止到此 标题总长度  apms_nums

                var apm_pre = 'am'
                if (!has_am && has_pm) {
                  apm_pre = 'pm'
                }

                // 取到所有标题
                for (var a = 1; a <= apms_nums; a++) {
                  $('.sch_p').text(
                    _this.global.formatTime(days_key[0], 'Y.M.D') +
                      '~' +
                      _this.global.formatTime(days_key[1], 'Y.M.D') +
                      '\xa0\xa0\xa0\xa0'
                  )
                  // $(".sch_p").text("时间："+_this.global.formatTime(days_key[0],"Y.M.D")+"~"+_this.global.formatTime(days_key[1],"Y.M.D")+"\xa0\xa0\xa0\xa0"+"地点："+config[area_id].title)
                  // <li class="col-xs-6 col-sm-6">产品创新/体验设计</li>
                  var li_str =
                    '<li class="col-xs-6 col-sm-6"  id="' +
                    obj.data.finishing[days_key[0]][a + apm_pre].groupId +
                    '" >' +
                    obj.data.finishing[days_key[0]][a + apm_pre]['name'] +
                    '</li>'
                  $('.wap_daohang').append(li_str)
                  // console.log(obj.data.finishing[days_key[0]][a+apm_pre]);
                }

                var con_keys = Object.keys(obj.data.datas)

                // 主标题的点击事件_开始
                $('.wap_daohang li').click(function () {
                  // 获取本课程的id
                  var groupId = $(this).attr('id')
                  $('.wap_content').html('')

                  var con_str = '<li  class="show">'
                  // 循环每一天
                  for (var b = 0; b < con_keys.length; b++) {
                    // console.log(con_keys[b]);
                    con_str +=
                      '<h6>' +
                      _this.global.formatTime(con_keys[b], 'Y/M/D') +
                      ' ' +
                      getWeek(new Date(_this.global.formatTime(con_keys[b], 'Y/M/D'))) +
                      '</h6>'
                    con_str +=
                      '<div class="rad row" id="' + con_keys[b] + '" >'

                    // con_keys[b]
                    var one_keys = Object.keys(obj.data.datas[con_keys[b]])
                    // 循环上下午
                    for (var d = 0; d < one_keys.length; d++) {
                      // console.log(one_keys[d]);
                      // console.log(obj.data.datas[con_keys[b]][one_keys[d]])
                      var hour_keys = Object.keys(
                        obj.data.datas[con_keys[b]][one_keys[d]]
                      )
                      // 上下午内时间点循环
                      for (let e = 0; e < hour_keys.length; e++) {
                        var x_keys = Object.keys(
                          obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]
                        )
                        // console.log(x_keys);
                        for (let f = 0; f < x_keys.length; f++) {
                          // 判断是否为当前课程的id
                          // console.log(x_keys[f]+'   '+groupId);
                          if (x_keys[f].toString() === groupId.toString()) {
                            // /
                            con_str +=
                              '<div class="col-sm-12 col-xs-12">' +
                              '<a href="/course?id=' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].courseId +
                              '&sid=' +
                              area_id +
                              '">' +
                              '<h2> ' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].courseTitle +
                              '</h2>' +
                              '<div>' +
                              '<div class="img">' +
                              '<img src="../../static/images/anli_logo.png" width="100%" />' +
                              '</div>' +
                              '<div class="wenz">' +
                              '<p>' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].name +
                              '<span>' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].company +
                              '' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]][x_keys[f]].lecturers[0].position +
                              '</span>' +
                              '</p>' +
                              '<span class="glyphicon glyphicon-time title_time"></span>' +
                              '<span class="time">' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]['time'][0] +
                              '~' +
                              obj.data.datas[con_keys[b]][one_keys[d]][hour_keys[e]]['time'][1] +
                              '</span>' +
                              '</div>' +
                              '</div>' +
                              '</a>' +
                              '</div>'
                            // /
                          }
                        }
                      }
                    }

                    // for(var c=0;c)

                    con_str += '</div>'
                  }
                  con_str += '</li>'
                  $('.wap_content').html(con_str)
                }) /// /主标题的点击事件 --结束
                // 默认执行一次第一个按钮的点击事件
                var project = ''
                if (_this.getQueryString('project') != null) {
                  project = _this.getQueryString('project')
                  if (project.toString() === '1') {
                    $('.wap_daohang #1').css({
                      background: '#0299d7',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #2a75bb',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][1 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '2') {
                    $('.wap_daohang #2').css({
                      background: '#ea078e',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #da0082',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][2 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '3') {
                    $('.wap_daohang #3').css({
                      background: '#ffae0d',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #ffae0d',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][3 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '4') {
                    $('.wap_daohang #4').css({
                      background: '#11aa48',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #019235',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][4 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '5') {
                    $('.wap_daohang #5').css({
                      background: '#9e9e9f',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #9e9e9f',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.finishing[days_key[0]][5 + apm_pre]['groupId']
                    ).click()
                  }
                } else {
                  $(
                    '#' +
                      obj.data.finishing[days_key[0]][1 + apm_pre]['groupId']
                  ).click()
                }
              } // mobile结束
              // 最外层按照日程 第一层循环 ---开始
              /// /////////////////////////////////////////////
            } else {
              console.log('请求错误')
            }
          }
        })
      } else {
        // 2018年mpd
        $.ajax({
          type: 'GET',
          url: `https://api.msup.com.cn/scheduling/new-get-schedule/${area_id}`,
          dataType: 'jsonp',
          success: function (obj) {
            // console.log(obj.data);
            const data = obj.data
            if (obj.errno && obj.errno.toString() === '0') {
              $('.sch_h1').text(_this.global.config[area_id].title)
              $('.sch_p').text(
                _this.global.formatTime(data.venueData.startTime, 'Y.M.D') +
                  '~' +
                  _this.global.formatTime(data.venueData.endTime, 'D')
              )

              $('.sch_p1').text(_this.global.config[area_id].trueplace)
              $('.sch_wap_h1').text(
                _this.global.config[area_id].year + _this.global.config[area_id].title + '站MPD日程'
              )
              // 判断是否为pc
              if (IsPC()) {
                var days_key = Object.keys(data.venueList)
                // 最外层按照日程 第一层循环 ---开始
                for (var i = 0; i < days_key.length; i++) {
                  var li_pre =
                    '<h1>' +
                    _this.global.formatTime(days_key[i], 'Y年M月D日') +
                    '</h1>' +
                    '<li class="show" id="' +
                    days_key[i] +
                    '">'
                  $('.content').append(li_pre)
                  let topData = obj.data.venueList[days_key[i]].slice(
                    0,
                    obj.data.venueList[days_key[i]].length / 2
                  )
                  let bottomData = obj.data.venueList[days_key[i]].slice(
                    obj.data.venueList[days_key[i]].length / 2,
                    obj.data.venueList[days_key[i]].length
                  )
                  $('#' + days_key[i]).append(
                    '<div class="shangwu"> <table class="title" id="sw_' +
                      days_key[i] +
                      '" >'
                  )
                  $('#' + days_key[i]).append(
                    '<div class="xiawu"> <table class="title" id="xw_' +
                      days_key[i] +
                      '" >'
                  )
                  // console.log(topData);
                  // console.log(bottomData);

                  var tr_str =
                    '<tr class="top"><td><img src="../../static/images/sch_time.png"/></td>'
                  for (let j = 1; j < 6; j++) {
                    // 追加上午的div start************
                    // 第二层循环A上午 填充标题操作 --开始
                    tr_str +=
                      '<td><img src="../../static/images/richeng/rc_0' +
                      j +
                      '.png" class="rc_img" /><h2>' +
                      obj.data.venueList[days_key[i]][j].venueName +
                      '<br>' +
                      '</h2></td>'
                  }
                  // 第二层循环A上午 填充标题操作 --结束
                  tr_str += '</tr>'
                  $('.shangwu #sw_' + days_key[i]).append(tr_str)
                  let tr_str_kc =
                    '<tr class="kecheng">' +
                    '<td><b>' +
                    _this.global.formatTime(topData[0].date, 'Y/M/D') +
                    getWeek(new Date(_this.global.formatTime(days_key[i], 'Y/M/D'))) +
                    '</b><br><br>' +
                    topData[0].startTime +
                    '<br>-<br>' +
                    topData[0].endTime +
                    '</td>'
                  let topLength
                  if (topData.length >= 6) {
                    topLength = 5
                  } else {
                    topLength = topData.length
                  }

                  for (let m = 0; m < topLength; m++) {
                    tr_str_kc += '<td valign="top">'
                    if (typeof topData[m] === 'undefined') {
                      // console.log('敬请期待');
                      tr_str_kc +=
                        '<div style="line-height: 180px;text-align: center;">敬请期待</div>'
                    } else {
                      tr_str_kc +=
                        '<a href="/course?id=' +
                        topData[m].courseId +
                        '&sid=' +
                        area_id +
                        '">' +
                        '<div class="biaoti">' +
                        topData[m].courseTitle +
                        '</div>' +
                        '<!-- <div class="img">' +
                        '<img src="../../static/images/anli_logo.png"/>' +
                        '</div> -->'
                      // 上午展示一堂课的讲师第一个人
                      tr_str_kc +=
                        '<div class="ren">' +
                        '<h2>' +
                        topData[m].lecturer[0]['lecturerName'] +
                        '</h2>' +
                        '<p>' +
                        topData[m].lecturer[0].lecturerCompany +
                        '<br>' +
                        topData[m].lecturer[0].lecturerPosition +
                        '</p>' +
                        '</div>'
                      tr_str_kc += '</a>'
                    }
                    tr_str_kc += '</td>'
                  }

                  $('.shangwu #sw_' + days_key[i]).append(tr_str_kc)
                  // 追加上午的div end************

                  $('#' + days_key[i]).append('</table></div>')

                  let tr_str2 =
                    '<tr class="top"><td><img src="../../static/images/sch_time.png"/></td>'
                  for (let k = 1; k < 6; k++) {
                    tr_str2 +=
                      '<td><img src="../../static/images/richeng/rc_0' +
                      k +
                      '.png" class="rc_img" /><h2>' +
                      obj.data.venueList[days_key[i]][k].venueName +
                      '<br>' +
                      '</h2></td>'
                  }
                  tr_str2 += '</tr>'

                  $('.xiawu #xw_' + days_key[i]).append(tr_str2)

                  let tr_str_kc2 =
                    '<tr class="kecheng">' +
                    '<td><b>' +
                    _this.global.formatTime(bottomData[0].date, 'Y/M/D') +
                    getWeek(new Date(_this.global.formatTime(days_key[i], 'Y/M/D'))) +
                    '</b><br><br>' +
                    bottomData[0].startTime +
                    '<br>-<br>' +
                    bottomData[0].endTime +
                    '</td>'
                  let bottomLength
                  if (bottomData.length >= 6) {
                    bottomLength = 5
                  } else {
                    bottomLength = bottomData.length
                  }
                  for (let n = 0; n < bottomLength; n++) {
                    tr_str_kc2 += '<td valign="top">'
                    if (typeof bottomData[n] === 'undefined') {
                      // console.log('敬请期待');
                      tr_str_kc2 +=
                        '<div style="line-height: 180px;text-align: center;">敬请期待</div>'
                    } else {
                      tr_str_kc2 +=
                        '<a href="/course?id=' +
                        bottomData[n].courseId +
                        '&sid=' +
                        area_id +
                        '">' +
                        '<div class="biaoti">' +
                        bottomData[n].courseTitle +
                        '</div>' +
                        '<!-- <div class="img">' +
                        '<img src="../../static/images/anli_logo.png"/>' +
                        '</div> -->'
                      // 上午展示一堂课的讲师第一个人
                      tr_str_kc2 +=
                        '<div class="ren">' +
                        '<h2>' +
                        bottomData[n].lecturer[0]['lecturerName'] +
                        '</h2>' +
                        '<p>' +
                        bottomData[n].lecturer[0].lecturerCompany +
                        '<br>' +
                        bottomData[n].lecturer[0].lecturerPosition +
                        '</p>' +
                        '</div>'
                      tr_str_kc2 += '</a>'
                    }
                    tr_str_kc2 += '</td>'
                  }
                  $('.xiawu #xw_' + days_key[i]).append(tr_str_kc2)
                  $('#' + days_key[i]).append('</table></div>')
                  // 第二层循环A上午 填充标题操作 --结束
                  var li_end = '</table></li>'
                  $('.content').append(li_end)
                }
              } // 判断是pc结束
              else {
                // mobile开始
                // 拿出第一天的所有上下午标题键
                var days_key = Object.keys(obj.data.venueList)

                // 取到所有标题
                for (var a = 1; a <= 4; a++) {
                  $('.sch_p').text(
                    _this.global.formatTime(days_key[0], 'Y.M.D') +
                      '~' +
                      _this.global.formatTime(days_key[1], 'Y.M.D') +
                      '\xa0\xa0\xa0\xa0'
                  )
                  // $(".sch_p").text("时间："+_this.global.formatTime(days_key[0],"Y.M.D")+"~"+_this.global.formatTime(days_key[1],"Y.M.D")+"\xa0\xa0\xa0\xa0"+"地点："+config[area_id].title)
                  // <li class="col-xs-6 col-sm-6">产品创新/体验设计</li>
                  var li_str =
                    '<li class="col-xs-6 col-sm-6"  id="' +
                    a +
                    '" >' +
                    obj.data.venueList[days_key[0]][a].venueName +
                    '</li>'
                  $('.wap_daohang').append(li_str)
                  // console.log(obj.data.finishing[days_key[0]][a+apm_pre]);
                }

                // 主标题的点击事件_开始
                $('.wap_daohang li').click(function (e) {
                  // 获取本课程的id
                  var groupId = $(this).attr('id')
                  $('.wap_content').html('')

                  var con_str = '<li  class="show">'
                  // 循环每一天
                  for (var b = 0; b < days_key.length; b++) {
                    // console.log(con_keys[b]);
                    con_str +=
                      '<h6>' +
                      _this.global.formatTime(days_key[b], 'Y/M/D') +
                      ' ' +
                      getWeek(new Date(_this.global.formatTime(days_key[b], 'Y/M/D'))) +
                      '</h6>'
                    con_str +=
                      '<div class="rad row" id="' + days_key[b] + '" >'

                    // con_keys[b]
                    one_keys = Object.keys(obj.data.venueList[days_key[b]])
                    // 循环上下午
                    const sortData = obj.data.venueList[days_key[b]].filter(
                      item => item.venueName === e.target.innerText
                    )

                    for (let d = 0; d < sortData.length; d++) {
                      con_str +=
                        '<div class="col-sm-12 col-xs-12">' +
                        '<a href="/course?id=' +
                        sortData[d].courseId +
                        '&sid=' +
                        area_id +
                        '">' +
                        '<h2> ' +
                        sortData[d].courseTitle +
                        '</h2>' +
                        '<div>' +
                        '<div class="img">' +
                        '<img src="../../static/images/anli_logo.png" width="100%" />' +
                        '</div>' +
                        '<div class="wenz">' +
                        '<p>' +
                        sortData[d].lecturer[0].lecturerName +
                        '<span>' +
                        sortData[d].lecturer[0].lecturerCompany +
                        '' +
                        sortData[d].lecturer[0].lecturerPosition +
                        '</span>' +
                        '</p>' +
                        '<span class="glyphicon glyphicon-time title_time"></span>' +
                        '<span class="time">' +
                        sortData[d].startTime +
                        '~' +
                        sortData[d].endTime +
                        '</span>' +
                        '</div>' +
                        '</div>' +
                        '</a>' +
                        '</div>'
                    }
                  }
                  con_str += '</div>'
                  con_str += '</li>'
                  $('.wap_content').html(con_str)
                }) /// /主标题的点击事件 --结束
                // 默认执行一次第一个按钮的点击事件
                $('.wap_daohang li:first-child').click()
                var project = ''
                if (_this.getQueryString('project') != null) {
                  project = _this.getQueryString('project')
                  if (project.toString() === '1') {
                    $('.wap_daohang #1').css({
                      background: '#0299d7',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #2a75bb',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.venueList[days_key[0]][1 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '2') {
                    $('.wap_daohang #2').css({
                      background: '#ea078e',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #da0082',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.venueList[days_key[0]][2 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '3') {
                    $('.wap_daohang #3').css({
                      background: '#ffae0d',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #ffae0d',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.venueList[days_key[0]][3 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '4') {
                    $('.wap_daohang #4').css({
                      background: '#11aa48',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #019235',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.venueList[days_key[0]][4 + apm_pre]['groupId']
                    ).click()
                  }
                  if (project.toString() === '5') {
                    $('.wap_daohang #5').css({
                      background: '#9e9e9f',
                      'box-shadow': '0.1rem 0.1rem 0.1rem #9e9e9f',
                      color: '#FFFFFF'
                    }),
                    $(
                      '#' + obj.data.venueList[days_key[0]][5 + apm_pre]['groupId']
                    ).click()
                  }
                } else {
                  // $('#' + obj.data.venueList[days_key[0]][1 + apm_pre]['groupId']).click();
                }
              } // mobile结束
              // 最外层按照日程 第一层循环 ---开始
              /// /////////////////////////////////////////////
            } else {
              console.log('请求错误')
            }
          }
        })
      }

      function getWeek (date) {
        var week
        if (date.getDay() === 0) week = '星期日'
        if (date.getDay() === 1) week = '星期一'
        if (date.getDay() === 2) week = '星期二'
        if (date.getDay() === 3) week = '星期三'
        if (date.getDay() === 4) week = '星期四'
        if (date.getDay() === 5) week = '星期五'
        if (date.getDay() === 6) week = '星期六'
        return week
      }

      function IsPC () {
        var userAgentInfo = navigator.userAgent
        var Agents = [
          'Android',
          'iPhone',
          'SymbianOS',
          'Windows Phone',
          'iPad',
          'iPod'
        ]
        var flag = true
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false
            break
          }
        }
        return flag
      }

      // …………………………………………………………………………………………………………………………………………………………………………………………………………………………………………………………………………
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Schedule_.vue